<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已审核</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">商品盘点单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userDisplayName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate?documentItem.businessDate.replace(' 00:00:00', ''):''}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
				<Col span="8">单据编号：{{documentItem.code}}</Col>
				<Col span="8">业务日期：{{documentItem.businessDate?documentItem.businessDate.replace(' 00:00:00', ''):''}}</Col>
				<Col span="8">业务员：{{documentItem.userDisplayName}}</Col>
			</Row>
			<Row class="div-content-row">
				<Col span="8">制单日期：{{documentItem.createDate?documentItem.createDate.toString().replace(' 00:00:00', ''):''}}</Col>
				<Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					商品信息
				</div>
			</div>
			<Table :columns="commodityColumn" :data="documentItem.inventorySheetDetailLists"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
		<div id="voucher-bottomBar">
			<table style="float: left;">
				<tr>
					<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
						<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">盈亏总额：</span>
						<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.lossAmount}}</span>
					</td>
					<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
						<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">盈亏总数：</span>
						<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.lossQuantity}}</span>
					</td>
				</tr>
			</table>
		</div>
		<div class="list-module" style="display: flex;justify-content: flex-end;">
			<button class="jxyd-button jxyd-primary" title="打印单据" @click="printDocument()">
				<Icon type="md-print" size='18' />
				打印
			</button>
			<button class="jxyd-button jxyd-primary" title="复制单据" @click="copyDocument(documentItem)">
				<Icon type="md-print" size='18' />
				复制
			</button>
		</div>
		<!-- 使用封装的自定义抽屉组件 -->
		<CustomDrawer v-model="batchCodeListModal" :title="`盘点批次库存`" :width="700" placement="right" :mask="true"
			:mask-closable="true" :closable="true">
			<template #title>
				<div class="drawer-title">
					<div class="drawer-title-left">
						<Icon type="ios-search" :size='18' />
						盘点批次库存
					</div>
					<div class="drawer-title-right"></div>
				</div>
			</template>
			<div class="drawer-content">
				<Table :height='pageHeight' disabled-hover :columns="batchCodeListColumn" :data="getBatchCodeDetails">
				</Table>
			</div>
			<template #footer>
				<div class="selected-sku">
					<!-- <Icon type="md-cart" size='20' />
						<Badge :count="getCurrentCommodityQuantity">
							<span>合计:&nbsp;¥{{getCurrentCommodityAmount}}</span>
						</Badge> -->
				</div>
				<button class="jxyd-button" @click="batchCodeListModal = false" style="margin-right: 10px;">取消</button>
				<button class="jxyd-button jxyd-primary" type="primary" @click="batchCodeListModal = true">确定</button>
			</template>
		</CustomDrawer>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'inventorysheetdetail',
		mixins: [printMixin],
		components: {
			DocumentFile,
			CustomDrawer
		},
		computed: {
			getBatchCodeDetails() {
				if (this.batchCodeIndex > -1 && this.documentItem.inventorySheetDetailLists.length > 0) {
					return this.documentItem.inventorySheetDetailLists[this.batchCodeIndex].inventorySheetBatchCodeDetails;
				}
				return [];
			},
		},
		data() {
			return {
				pageHeight: 0,
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					depotId: '',
					depotName: '',
					lossQuantity: 0,
					lossAmount: 0,
					inventorySheetDetailLists: [],
					userId: '',
					userDisplayName: '',
					creator: '0',
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				batchCodeIndex: -1,
				batchCodeListModal: false,
				batchCodeListColumn: [{
						title: '批次号',
						key: 'batchCode',
						width: 180
					},
					{
						title: '计量单位',
						key: 'unit',
						render: (h, params) => {
							return h('span', {}, this.documentItem.inventorySheetDetailLists[this.batchCodeIndex]
								.unit);
						}
					},
					{
						title: '账存数',
						key: 'accountBalance'
					},
					{
						title: '实际数量',
						key: 'actualNumbers'
					},
					{
						title: '盈亏数',
						key: 'deficiency'
					}
				],
				commodityColumn: [{
						title: '商品',
						key: 'commodityName',
						fixed: 'left',
						width: 300,
						render: (h, params) => {
							return h('a', {
									class: 'jxyd-a',
									on: {
										click: (e) => {
											this.$router.push({
												path: 'commoditydetailinfo',
												query: {
													commodityId: params.row.priceTypeData
														.commodityPriceTypeGroup.commodity.id
												}
											});
										}
									}
								}, params.row.priceTypeData
								.commodityPriceTypeGroup.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 300,
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 200
					},
					{
						title: '帐存数量',
						key: 'accountBalance',
						width: 200
					},
					{
						title: '实际数量',
						key: 'actualNumbers',
						width: 200
					},
					{
						title: '单价',
						key: 'price',
						width: 200
					},
					{
						title: '盈亏数',
						key: 'deficiency',
						width: 200
					},
					{
						title: '盈亏额',
						key: 'lossAmount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						fixed: 'right',
						width: 120,
						render: (h, params) => {
							let btnArray = [];
							if (params.row.priceTypeData.commodityPriceTypeGroup
								.commodity.enableBatch) {
								btnArray.push(h('a', {
									class: 'jxyd-a',
									props: {},
									style: {
										'margin-right': '10px'
									},
									on: {
										click: (val) => {
											this.batchCodeIndex = params.index;
											this.batchCodeListModal = true;
										}
									}
								}, "查看批次"));
							}
							return btnArray;
						}
					}
				]
			}
		},
		methods: {
			getInventorySheet(inventorySheetId) {
				let self = this;
				request.get('/api/InventorySheet/GetInventorySheetPriceType', {
					params: {
						id: inventorySheetId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			getInventorySheetByCode(inventorySheetCode) {
				let self = this;
				request.get('/api/InventorySheet/GetInventorySheetByCodePriceType', {
					params: {
						code: inventorySheetCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
				}).catch(function(error) {})
			},
			async copyDocument(param) {
				let self = this;
				await this.$Modal.confirm({
					title: "操作警告",
					content: "是否复制单据？",
					async onOk() {
						let result = await request.get('api/InventorySheet/GetNextCode', {
							params: {
								prefix: 'PDD'
							}
						});
						if (!result || result.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: "获取编号失败"
							});
							return;
						}
						let data = JSON.parse(JSON.stringify(param));
						data.id = 0;
						data.code = result.data;
						data.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
						data.createDate = data.businessDate;
						data.userId = parseInt(localStorage.getItem("userId"));
						data.userDisplayName = localStorage.getItem("userName");
						data.creator = parseInt(localStorage.getItem("userId"));
						data.checkState = 1;
						self.dataSubmitAndCheck(data);
					},
					onCancel() {}
				});
			},
			dataSubmitAndCheck(data) {
				let self = this
				request.post('/api/InventorySheet/EditInventorySheet', data).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					//记录商品盘点单操作
					var log = {
						FlowId: response.data,
						Title: '商品盘点单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此商品盘点单' : '创建了此商品盘点单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			printDocument() {
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'inventorySheetList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}

				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));

				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};

				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}

					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});

					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});

					return totals;
				};

				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						// 处理 "2026-03-19 00:00:00" 或 "2026-03-19" 格式
						return dateStr.split(' ')[0];
					}
					return '';
				};

				// 格式化单条商品盘点单记录
				const formatSingle = (record) => {
					if (!record) return {};

					// 格式化盘点商品明细
					let commodityRaw = (record.inventorySheetDetailLists || []).map(item => ({
						name: item.commodityName || '',
						format: item.format || '',
						unit: item.unit || '',
						price: safeNumber(item.price),
						accountBalance: safeNumber(item.accountBalance), // 账存数量
						actualNumbers: safeNumber(item.actualNumbers), // 实际数量
						deficiency: safeNumber(item.deficiency), // 盈亏数量
						lossAmount: safeNumber(item.lossAmount) // 盈亏金额
					}));

					// 添加序号
					let commodityStockDetail = addSerialNo(commodityRaw);

					// 添加合计行
					if (commodityRaw.length > 0) {
						const totals = calcTotals(commodityRaw, ['accountBalance', 'actualNumbers', 'deficiency',
							'lossAmount'
						]);
						commodityStockDetail.push({
							serialNo: '',
							name: '',
							format: '',
							unit: '合计',
							price: '',
							accountBalance: totals.accountBalance,
							actualNumbers: totals.actualNumbers,
							deficiency: totals.deficiency,
							lossAmount: totals.lossAmount,
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}

					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userDisplayName || record.userName || '',
						businessDate: formatDate(record.businessDate),
						depotName: record.depotName || '',
						note: record.note || '',
						commodityStockDetail: commodityStockDetail
					};
				};

				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
		},
		watch: {
			'$route.query.inventorySheetId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getInventorySheet(param);
					}
				}
			},
			'$route.query.inventorySheetCode': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getInventorySheetByCode(param);
					}
				}
			}
		},
		created: function() {
			this.$nextTick(() => {
				let contentElement = document.querySelector(".main-content");
				this.pageHeight = contentElement ? contentElement.offsetHeight - 100 : 700;
			})
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.list-base {
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}

	.list-base-left {
		float: left;
		display: flex;
		color: #000;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 100%;
		/* 父元素需要固定高度或其他百分比高度 */
	}

	.list-base-left-span {
		font-size: 18px;
	}

	.list-base-right {
		display: flex;
		float: right;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 36px;
	}

	.list-base-right-span {
		margin-left: 10px;
	}

	.span-back-color {
		color: #000;
	}

	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.list-module {
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}

	.div-content-row div {
		padding: 15px;
	}

	.div-content-row-center div {
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}

	.amount-color {
		color: rgb(255, 106, 127);
	}

	.div-content-detail {
		margin: 15px;
		background-color: #f8f8f9;
		padding: 20px;
	}

	.div-content-detail-title {
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}

	.div-content-detail-list {
		margin-top: 10px;
	}

	.div-content-detail-list-title {
		text-indent: 0.5em;
	}

	.div-content-detail-list-content {
		overflow: hidden;
	}

	.div-content-detail-list-content-item {
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}
</style>